module.exports = __webpack_public_path__ + "img/napoli.2c3dcd04.png";